"use client";

import { cn } from "@/lib/utils";
import { useModal } from "@/providers/modal-provider";
import { ModalType } from "@/types/modal-type";

const SignupButton = ({ size = "md" }: { size?: "sm" | "md" }) => {
	const { openModal } = useModal();

	return (
		<button
			type="button"
			onClick={() => openModal(ModalType.Auth)}
			className={`focus:ring-offset-slate-50", inline-flex animate-shimmer items-center justify-center rounded bg-[linear-gradient(110deg,#005EFF,45%,rgba(0,190,255,0.7),55%,#005EFF)] bg-[length:200%_100%] font-medium text-white transition-colors focus:outline-none focus:ring-2 focus:ring-white focus:ring-offset-2 ${
				size === "sm" ? "px-4 py-1.5" : "px-6 py-2"
			}`}
		>
			<span className={cn("text z-10 whitespace-nowrap text-white", size && "text-sm")}>
				Sign Up
			</span>
		</button>
	);
};

export default SignupButton;
